import styled from 'styled-components';
import theme from '../../../../styles/defaultTheme';

export const DependenteBlock = styled.div`
    display: flex;
    align-items: center;
    border-bottom: 1px solid #3A3E40;

    ${({ index }) => `background-color: ${index % 2 === 0 ? '#BAC4C2' : 'white'}`};
`;

export const DependenteIndex = styled.div`
    min-width: 12px;
    text-align: center;
`;

export const CheckTitled = styled.div`
    display: flex;
    justify-content: space-evenly;
    padding-top: 3px;
`;

export const Container = styled.div`
    width: 555px;
    font-size: ${theme.font.size10};
    border: 1px solid #3A3E40;
    margin: 20px 0px 0px 20px;

    & * {
        letter-spacing: .5px;
    }
`;

export const GroupFields = styled.div`
    display: flex;
    margin-left: -1px;

    & * {
        letter-spacing: .8px;
    }
`;

export const GroupChecksSingle = styled(GroupFields)`
    flex-wrap: wrap;

    & div {
        width: 25%;
    }
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px;
    width: 100%;
`;

export const Label = styled.div`
    font-size: ${theme.font.size11};
    font-weight: bold;
    text-transform: uppercase;

    margin-left: 10px;
    margin-bottom: 10px;
`;

export const TitleBar = styled.div`
    text-transform: uppercase;
    margin: 10px;

    color: white;
    font-weight: bold;
    text-align: center;

    background: black;
    border-radius: 7px;

    font-size: ${theme.font.size10};
    letter-spacing: 2px;
`;

export const LogoGroup = styled.div`
    display: flex;
`;

export const Logo = styled.img`
    width: 120px;
    height: 40px;
    margin: 0 10px;
`;

export const Divisor = styled.div`
    border-left: 1px solid #ccc;
`;

export const DivisorLaw = styled(Divisor)`
    height: 100%;
    color: black;
    width: 2px;
    margin: 0 10px;
    background: black;
`;

export const NumMotion = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 0px 30px;

    border: 1px solid black;
    border-radius: 10px;

    color: #868888;

    & label {
        font-weight: bold;
        margin-bottom: 5px;
    }

    & span {
        font-size: ${theme.font.size8};
    }
`;

export const Topics = styled.ul`
    list-style: none;
    font-size: ${theme.font.size6};
    padding: 0 20px;
`;

export const NumMotionLaw = styled(NumMotion)`
    display: flex;
    flex-direction: row;
    width: 200px;
    padding: 0 10px;


    & section {
        display: flex;
        flex-direction: column;
        text-align: center;
        width: 200px;
        padding: 0 4px;
        font-size: ${theme.font.size8};
    }
`;

export const Legend = styled.div`
    display: flex;
    font-size: ${theme.font.size7};
`;

export const LegendTitle = styled.div`
    font-size: ${theme.font.size6};
    color: #8E8F8F;
`;

export const LegendSubTitle = styled(LegendTitle)``;

export const FirstLegend = styled.div`
    display: flex;   
    flex-direction: column;
    width: 45%;
`;

export const SecondLegend = styled(FirstLegend)`
    width: 65%;
`;

export const SpacingTextCustom = styled.div`
    padding: 10px 10px 0px 10px;
`;

export const TextCustom = styled(FirstLegend)`
    font-size: ${theme.font.size9};
    color: #8E8F8F;
    width: 100%;
`;

export const ContainerCartaOrientacao = styled.div`
    width: 555px;
    margin: 20px 0px 0px 20px;

    & * {
        letter-spacing: 0.5px;
    }
`;

export const BodyCartaOrientacao = styled.div`
    margin: 20px 0px 0px 20px;
`;

export const TextBold = styled.span`
    font-weight: bold;
    letter-spacing: 1px;
`;

export const TextBoldCapitalize = styled(TextBold)`
    text-transform: capitalize;
    font-size: ${theme.font.size12};
    width: 100%;
`;

export const BoxText = styled.div`
    background-color: #E5E7E6;
    width: 100%;
    border-top: 5px solid;
    border-bottom: 5px solid;
    border-left: 1px solid;
    border-right: 1px solid;
    padding: 12px 8px 12px 8px;
    margin: 12px 0 12px 0px;
`;

export const TextCartaOrientacao = styled.div`
    font-size: ${theme.font.size9};
    padding: 12px 0 0 0px;
    letter-spacing: 2px;

    & span.underlines {
        letter-spacing: -1px;
    }

    ${({ hasValue }) =>
        hasValue &&
        `
        & span.underlines {
            text-decoration: underline !important;
            letter-spacing: 0.5px !important;
            padding-bottom: 3px;
        }
    `}
`;

export const TextSpacing = styled.div`
    letter-spacing: 2px;
`;

export const TopicsText = styled(TextCartaOrientacao)`
    padding: 0 0 0 12px;
`;

export const TextSignature = styled(TextCartaOrientacao)`
    padding: 0px 0px 0px 70px;
`;

export const PageBreak = styled.div`
     margin: 120px 0 0 0px;
`;

export const SpacingSignature = styled.div`
     margin: 30px 0 0 0px;
`;
export const TableQuestions = styled.table`
    font-size: ${theme.font.size6};
    width: 100%;
    margin-bottom: 40px;

    & tr {
        border-bottom: 1px solid black;
    }

    & th {
        width: 25%;

        &:not(:last-child) {
            border-right: 1px solid black;
        }
    }

    & td {
        padding: 5px 0;

        &:not(:last-child) {
            border-right: 1px solid black;
        }
    }
`;

export const TitleForm = styled.div`
    text-align: center;
    font-weight: bold;
    font-size: ${theme.font.size8};
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 2px 0;
`;

export const FormContainer = styled.div`
    font-size: ${theme.font.size6};
`;

export const FormHeader = styled.div`

`;

export const FormRow = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const QuestionNumber = styled.div`
    font-weight: bold;
    margin-right: 3px;
`;

export const QuestionContent = styled.div`

`;

export const Answers = styled.div`
    display: flex;
    
    ${({ checks }) => {
        if (checks) {
            return 'width: 100%;';
        }

        return '';
    }}

    & div {
        ${({ checks }) => {
            if (checks) {
                return `
                    width: 93px;
                    justify-content: end;
                    width: 100%;
                `;
            }

            return '';
        }}
    }
`;

export const AnswerHeader = styled.div`

`;

export const FormFooter = styled.div`
    border-bottom: 1px solid;
    padding: 2px 0;
    margin-bottom: 10px;
    font-size: ${theme.font.size5};
`;

export const QuestionContainer = styled.div`
    display: flex;
    align-items: center;
    font-size: ${theme.font.size5};
    padding-bottom: 2px;
    border: 1px solid;
    width: 100%;
`;

export const Answer = styled.div`
    width: 35px;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    border: 1px solid black;
`;

export const Signature = styled.div`
    display: flex;
    border-top: 1px solid;
`;

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    font-size: ${theme.font.size7};

    &:not(:last-child) {
        border-right: 1px solid;
    }

    & label {
        margin-bottom: 30px;
    }
`;

export const HeaderDAP = styled(Header)`
    padding: 0 ;
`;

export const CardANS = styled.div`
    background-color: #000000;
    color: #FFFFFF;
    font-size: ${theme.font.size6};
    width: 12px;
    padding: 5px;
`;

export const TextCardANS = styled.div`
    text-orientation: upright;
`;

export const TitleBarRac = styled.div`
    display: flex;
    border-radius: 0;
    font-size: ${theme.font.size7};
    font-weight: 700;
    color: white;
    font-weight: bold;
    text-align: center;
    background: black;
    padding: 0 0 0 5px;
    letter-spacing: .03rem;
`;

export const AlignHeader = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: 255px;
`;

export const LabelDAC = styled.div`
    font-size: ${theme.font.size12};
    font-weight: bold;
    text-transform: uppercase;
`;

export const LabelHeader = styled.div`
    font-size: ${theme.font.size8};
    font-weight: bold;
`;

export const NumberDependent = styled.div`
    min-width: 23px;
    min-height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ContainerDependent = styled.div`
    display: flex;
`;

export const AlignDependent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const BoxValues = styled.div`
    height: 30px;
    border: 1px solid #000000;
`;

export const BoxValuesText = styled.div`
    white-space: nowrap;
    display: flex;
    justify-content: center;
    font-size: ${theme.font.size6};
    color: #868888;
    white-space: nowrap;
`;

export const TitleValidity = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const ContainerValidity = styled.div`
    display: flex;
`;

export const Text = styled.div`
    font-size: ${theme.font.size6};
   padding: 3px 6px;
`;

export const FontBold = styled.span`
   font-weight: 700;
`;

export const TextInfoGenaral = styled.div`
    font-size: ${theme.font.size8};
   padding: 5px 20px 0px 20px;
`;

export const SpacingPage = styled.div`
   height: 70px;
`;
